/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_StrengthInputs */

const en_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength`)
};

const es_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerza`)
};

const fr_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musculation`)
};

const de_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraft`)
};

const ja_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`筋力トレーニング`)
};

const zh_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`力量训练`)
};

const ar_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قوة`)
};

const id_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kekuatan`)
};

const it_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza`)
};

const ru_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Силовые тренировки`)
};

const pt_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força`)
};

const ko_val_strength = /** @type {(inputs: Val_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`근력 운동`)
};

/**
* | output |
* | --- |
* | "Strength" |
*
* @param {Val_StrengthInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_strength = /** @type {((inputs?: Val_StrengthInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_StrengthInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_strength(inputs)
	if (locale === "es") return es_val_strength(inputs)
	if (locale === "fr") return fr_val_strength(inputs)
	if (locale === "de") return de_val_strength(inputs)
	if (locale === "ja") return ja_val_strength(inputs)
	if (locale === "zh") return zh_val_strength(inputs)
	if (locale === "ar") return ar_val_strength(inputs)
	if (locale === "id") return id_val_strength(inputs)
	if (locale === "it") return it_val_strength(inputs)
	if (locale === "ru") return ru_val_strength(inputs)
	if (locale === "pt") return pt_val_strength(inputs)
	return ko_val_strength(inputs)
});